import { render } from "./App.vue?vue&type=template&id=27e0918c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=27e0918c&lang=css"
script.render = render

export default script